module.exports = __webpack_public_path__ + "static/open-source-logos-e0b6e39e5c12181e8260a4e2b40dd1e3.svg";